import { render, staticRenderFns } from "./Email-recovery.vue?vue&type=template&id=5a7f6d2a"
import script from "./Email-recovery.vue?vue&type=script&lang=js"
export * from "./Email-recovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports